import { EventFeedEvent } from '@toggle/toggle';
import clsx from 'clsx';
import React from 'react';

import { InsightsLivePrice } from '~/components/insights-live-price/InsightsLivePrice';
import { useEntities } from '~/react-query-hooks/entities/useEntities';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { getCardDate } from '~/utils/card-utils/card-utils';
import { CardPill } from '~/views/stream/components/stream-card/components/card-pill/CardPill';
import { useCatalystDrawer } from '~/widgets/catalyst-insights-drawer/useCatalystDrawer';
import { useMarketCatalystDrawer } from '~/widgets/market-catalyst-drawer/useMarketCatalystDrawer';

import styles from '../../OverviewEventFeed.module.scss';
import { getCatalystEntityTag, parseCatalystData } from './utils';

export interface CatalystRowProps {
  event: EventFeedEvent;
  isLast?: boolean;
}

export const CatalystRow = ({ event, isLast }: CatalystRowProps) => {
  const { openDrawer: openCompanyCatalystDrawer } = useCatalystDrawer();
  const { openDrawer: openMarketCatalystDrawer } = useMarketCatalystDrawer();
  const { eventDate, isMarketWide, cardType, themeId, subCategory } =
    parseCatalystData(event);

  const entityTag = getCatalystEntityTag(event);

  const { data: entities } = useEntities({
    entityTags: entityTag ? [entityTag] : [],
    enabled: !!entityTag,
  });
  const entity = entities?.[0];

  const handleClick = () => {
    if (isMarketWide && subCategory) {
      openMarketCatalystDrawer({
        type: subCategory,
        themeId,
        insightId: event.source_id,
        source: POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW,
      });
    } else {
      openCompanyCatalystDrawer({
        type: 'company',
        entityTag: event.entity,
        insightId: event.source_id,
        source: POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW,
      });
    }
  };

  return (
    <div
      className={clsx(styles.feedItemWrapper, {
        [styles.last]: isLast,
      })}
    >
      <div className={styles.feedItem} onClick={handleClick}>
        <div className={styles.feedItemHeader}>
          <CardPill type={cardType} />
        </div>
        <p className={styles.insightTitle}>{event.title}</p>
        <div className={styles.statsRow}>
          <div className={styles.statsContainer}>
            {entity && (
              <InsightsLivePrice
                entity={entity}
                isHorizontalView
                showPricePercentage
                showDotSeparator
              />
            )}
          </div>
          <span className={styles.timeAgo}>{getCardDate(eventDate)}</span>
        </div>
      </div>
    </div>
  );
};
